<template>
  <InfoCard title="联系人">
    <div class="concat-info">
      <div class="info-row">
        <div class="label">手机号码</div>
        <div class="value">{{ contact.mobile }}</div>
      </div>
      <div class="info-row">
        <div class="label" style="width: 76px">联系邮箱</div>
        <div class="value" :title="contact.email">{{ contact.email }}</div>
      </div>
    </div>
  </InfoCard>
</template>

<script>
import InfoCard from "@/views/components/infoCard.vue";
export default {
  name: "ConcatInfoCard",
  components: { InfoCard },
  props: {
    contact: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="less" scoped>
.concat-info {
  display: flex;
  gap: 52px;
  .info-row {
    flex: 1;
    min-width: 220px;
  }
}
</style>
